<template> 
  <el-card class="form-container" shadow="never">
    <student-form v-if="personalType==='student'" :form='form' :isPersonalInfo='true' :isEdit='true' @afterSubmit="afterSubmit" :lazy="true"></student-form>
    <teacher-form v-if="personalType==='teacher'" :form='form' :isEdit='true' @afterSubmit="afterSubmit" :lazy="true"></teacher-form>
  </el-card>
</template>
<script>
import { mapState } from "vuex"
import StudentForm from "@views/student/studentForm.vue"
import TeacherForm from "@views/teacher/teacherForm.vue"
import { selectOneStudent } from '@/api/student'
import { selectOneTeacher } from '@/api/teacher'
const ROLE_STUDENT='student',ROLE_TEACHER='teacher'
export default {
  name: 'personalInfo',
  components: { StudentForm, TeacherForm },
  data() {
    return {
      personalType: '',
      form: {},
      account:localStorage.getItem('account')
    }
  },
  computed: {
     ...mapState({      
      userRoles: ({ user }) => user.roles,
    }), 
  }, 
  created() {
    // if (!localStorage.getItem('user')) {
    //   return;
    // }
    // let user = JSON.parse(localStorage.getItem('user'))
    if(!this.userRoles){
      return
    }
    if( _.includes(this.userRoles,ROLE_STUDENT)) {
      this.personalType = ROLE_STUDENT
      selectOneStudent(this.account).then(response => {
        let formObj = response.data.data
        this.form = Object.assign({},formObj)
      })
    } else if( _.includes(this.userRoles,ROLE_TEACHER)){
      this.personalType = ROLE_TEACHER
      selectOneTeacher(this.account).then(response => {
        let formObj = response.data.data
        this.form = Object.assign({},formObj)
      })
    }
  },
  methods: {
    afterSubmit() {
      // this.dialogVisible = false
      // this.loadData()
    },
  }
}
</script>
<style>
</style>
